import { render, staticRenderFns } from "./complaints.vue?vue&type=template&id=394b54a7&scoped=true"
import script from "./complaints.vue?vue&type=script&lang=js"
export * from "./complaints.vue?vue&type=script&lang=js"
import style0 from "./complaints.vue?vue&type=style&index=0&id=394b54a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b54a7",
  null
  
)

export default component.exports